<template>
  <div id="app">
    <Container/>
  </div>
</template>

<script>
import Container from './components/Container.vue'; // eslint-disable-next-line

export default {
  name: 'app',
  components: {
    Container,
  },
};
</script>

<style>
#app {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom left, #FFF, #ECE9E6);
  font-family: 'Quicksand', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #1D1D1D;
}
</style>
